/**
 * Watch Stream Layout
 * Parent route for all /watch/:streamerId/* routes
 * Renders child routes via Outlet
 */

import { useEffect } from 'react';
import { useParams, useNavigate, useLocation, Outlet } from 'react-router';

export default function WatchStreamLayout() {
    const { streamerId } = useParams<{ streamerId: string }>();
    const navigate = useNavigate();
    const location = useLocation();

    // Redirect /watch/:streamerId to /watch/:streamerId/before-entry
    // Handle both encoded and decoded pathnames for Japanese characters
    useEffect(() => {
        if (streamerId) {
            const decodedPath = decodeURIComponent(location.pathname);
            const expectedPath = `/watch/${streamerId}`;
            // Only redirect if we're exactly at /watch/:streamerId (not a child route)
            if (decodedPath === expectedPath || location.pathname === expectedPath) {
                navigate(`/watch/${encodeURIComponent(streamerId)}/before-entry`, { replace: true });
            }
        }
    }, [streamerId, navigate, location.pathname]);

    // Render child routes
    return <Outlet />;
}
